export default __webpack_public_path__ + "static/about-us-3433aabf780416b1bd59b047ae7927bb.jpg";